import React from 'react';
import './AboutEvent.scss';
import { ReactComponent as ArrowIcon } from '../assets/chevron_backward_large.svg';
import Content from './Content';
import { ContentStatusEnum, PageDetails } from './Session';

export interface AboutEventProps {
  back: () => void;
  page: PageDetails;
}

const AboutEvent: React.FC<AboutEventProps> = ({ back, page }) => {
  return (
    <div className="content-container">
      <div className="content-header">
        <button onClick={back} className="small">
          <ArrowIcon /> Back
        </button>

        <h1>About the event</h1>
      </div>
      <Content page={page} contentStatus={ContentStatusEnum.Showing} />
    </div>
  );
};

export default AboutEvent;
